
<div class="form__group--border pt-32 pb-16">
  <fieldset>
    <legend class="form__label pb-8">{{ legend }}</legend>
    <ul>
      <li v-for="ageRange in ageRanges" :key="ageRange.value">
        <PoppinsCheckbox
          v-model="ageGroups"
          :labelName="ageRange.optionText"
          :aria-label="generateScreenReaderLabel(ageRange.optionText)"
          :value="ageRange.value"
        />
      </li>
    </ul>
  </fieldset>
</div>
